import appStore from '../utils/state';

export default class FiltersButton extends HTMLElement {
  private button: HTMLButtonElement | null = null;

  private onClickBound = this.onClick.bind(this);

  constructor() {
    super();
  }

  connectedCallback(): void {
    this.button = this.querySelector('[data-filters-button-ref="button"]');

    this.addEventListeners();
  }

  addEventListeners(): void {
    if (this.button) {
      this.button.addEventListener('click', this.onClickBound);
    }
  }

  removeEventListeners(): void {
    if (this.button) {
      this.button.removeEventListener('click', this.onClickBound);
    }
  }

  onClick(): void {
    appStore.actions.toggleFiltersModal();
  }

  disconnectedCallback(): void {
    this.removeEventListeners();
  }
}

customElements.define('filters-button', FiltersButton);
